import { parseString } from "xml2js";
import { diosmAepsDailyLogin, diosmAepsEkycBiometric, diosmBalanceEnquiry, diosmCashwithdrawal, diosmGetMerchantDetail, diosmGetMerchantOtp, diosmGetMerchantOtpVerify, diosmMiniStatement, getCheckDiosmLoginStatus } from "../../utils/api";



const initialControls = {
	transactionType: '',
	aadharNumber: '',
	amount: '',
	bank: '',
	mobileNumber: '',
};


export const diosmMerchantDetail = (setLoading,setAepsStatus,setAlert,position) => {
    setLoading(true);
    const params = {
        latitude:position?.latitude,
	    longitude:position?.longitude
    }
    diosmGetMerchantDetail(params).then((resp) => {
        setLoading(false);
        if (resp?.success) {
            if (resp?.data) {
            
                checkDiosmLoginStatus(setLoading,setAepsStatus,setAlert);
              
            } else {
                setAepsStatus('selectDeviceForVerify');

                setAlert({ type: 'success', msg: 'Please verify retailer fingerprint.', });
            }
        } else {
            if (resp?.errorCodeList.length > 0) {
                setAlert({ type: 'error', msg: resp?.errorCodeList[0],  });
                if(resp?.errorCodeList[0] === "Please contact admin."){
                    return;
                }
                sendOtp(setLoading,setAepsStatus,setAlert,position);
            } else {
                setAlert({ type: 'error', msg: resp?.msg,  });
            }
        }
    });
};


const checkDiosmLoginStatus = (setLoading,setAepsStatus,setAlert) => {
    setLoading(true);

    getCheckDiosmLoginStatus().then((resp) => {
        setLoading(false);
        if (resp?.success) {
            setAepsStatus("yes");
            
        } else {
            setLoading(false);
            
            setAepsStatus('selectDevice');
            if (resp?.errorCodeList.length > 0) {
                setAlert({ type: 'error', msg: resp?.errorCodeList[0],  });
                
            } else {
                setAlert({ type: 'error', msg: resp?.msg,  });
            }
        }
    });
};

function getPosition(string, subString, index) {
    return string.split(subString, index).join(subString).length;
}

 export const sendOtp = (setLoading,setAepsStatus,setAlert,position) => {
    setLoading(true);
    const params = {
        latitude:position?.latitude,
	    longitude:position?.longitude
    }
    diosmGetMerchantOtp(params).then((resp) => {
        setLoading(false);
        if (resp?.success) {
            //setAepsStatus('verifyCustomer');
            setAepsStatus('verifOtp');
            setAlert({ type: 'success', msg: resp?.msg,  });
        } else {
            setAepsStatus('dailyLogin');
            if (resp?.errorCodeList.length > 0) {
                setAlert({ type: 'error', msg: resp?.errorCodeList[0], });
            } else {
                setAlert({ type: 'error', msg: resp?.msg,  });
            }
        }
    });
};


export const diosmDailyLogin = (setLoading,setAepsStatus,setAlert,fingerPrirntData ,deviceType,controls) => {
 
    setLoading(true);
    const param = {
        merchantId: '',
        pid_xml_base64e: fingerPrirntData,
        serviceType:"AEPS"
    };
    diosmAepsDailyLogin(param).then((resp) => {
        setLoading(false);
        if (resp?.success) {
            localStorage.setItem("deviceType",deviceType);
            if(controls.transactionType ==="Withdrawal" ){
                setAepsStatus('verifyCustomer');
                setAlert({ type: 'success', msg: 'Retailer verification successful. Please scan customer fingerprint', });
            }else{
                setAepsStatus('yes');
            }
            
            
        } else {
            if (resp?.errorCodeList.length > 0) {
                setAlert({ type: 'error', msg: resp?.errorCodeList[0],  });
            } else {
                setAlert({ type: 'error', msg: resp?.msg, });
            }
        }
    });
};

export const diosmVerifyOtp = (setLoading,setAepsStatus,setAlert,otp,setOtp) => {
    const otpText = otp.join('');

    if (otpText.length < 6) {
        setAlert({ type: 'error', msg: 'Please enter 6 digit otp', });
    } else {
        setLoading(true);
        diosmGetMerchantOtpVerify(otpText).then((resp) => {
            setLoading(false);
            if (resp?.success) {
                setAlert({ type: 'success', msg: 'OTP verification successful. Please verify retailer fingerprint.' });
                setAepsStatus('selectDeviceForVerify');
            } else {
                setOtp(['', '', '', '', '', '']);
                if (resp?.errorCodeList.length > 0) {
                    setAlert({ type: 'error', msg: resp?.errorCodeList[0], });
                } else {
                    setAlert({ type: 'error', msg: resp?.msg,  });
                }
            }
        });
    }
};


export const diosmVerifyFingerprint = (setLoading,setAepsStatus,setAlert,fingerPrirntData,deviceType) => {
    const param = {
        merchantId: '',
        pid_xml_base64e: fingerPrirntData,
        // serviceType:"AEPS"
    };
    setLoading(true);
    diosmAepsEkycBiometric(param).then((resp) => {
        setLoading(false);
        if (resp?.success) {
            localStorage.setItem("deviceType",deviceType);
            setAepsStatus('yes');
            setAlert({ type: 'success', msg: 'Retailer fingerprint verification successful', });
        } else {
            if (resp?.errorCodeList.length > 0) {
                setAlert({ type: 'error', msg: resp?.errorCodeList[0],  });
            } else {
                setAlert({ type: 'error', msg: resp?.msg,  });
            }
        }
    });
};

let testMantraPort = 1;
export function DiosmCapture(param, type,deviceType,aepsStatus,setBankDataResp,overLayers,setOverLayer,setControls,setFingerprintLoader,controls,setAepsStatus,setAlert,setLoading) {
    var url = '';
    var PIDOPTS = '';
 
    setLoading(true);
    if (deviceType === 'Morpho') {
        if(aepsStatus ==="verifyFingerPrint"){
            
            PIDOPTS =
            '<PidOptions ver="1.0">' +
            '<Opts fCount="1" fType="2" iCount="" iType="" pCount="" pType="" format="0" pidVer="2.0" timeout="10000" otp="" wadh="E0jzJ/P8UopUHAieZn8CKqS4WPMi5ZSYXgfnlfkWjrc=" posh=""/>' +
            '</PidOptions>';
        }else{
        PIDOPTS =
            '<PidOptions ver="1.0">' +
            '<Opts fCount="1" fType="2" iCount="" iType="" pCount="" pType="" format="0" pidVer="2.0" timeout="10000" otp="" wadh="" posh=""/>' +
            '</PidOptions>';
        }
   
        if (testMantraPort === 1){
           
            url = 'http://127.0.0.1:11100/capture';
        }else{
            url = 'https://127.0.0.1:11100/capture';
        }
        // url = 'http://127.0.0.1:11100/capture';
    } else if (deviceType === 'Mantra') {
        if(aepsStatus ==="verifyFingerPrint"){
            PIDOPTS =
            '<PidOptions ver="1.0"> '+
            '<Opts fCount="1" fType="2" iCount="0" pCount="0" pgCount="1" format="0"   pidVer="2.0" timeout="10000"  wadh="E0jzJ/P8UopUHAieZn8CKqS4WPMi5ZSYXgfnlfkWjrc=" posh="" env="P" /> <CustOpts><Param name="mantrakey" value="" /></CustOpts>'+
            '</PidOptions>';
        }else{
                
                 PIDOPTS =
                 '<PidOptions ver="1.0"> '+
                 '<Opts fCount="1" fType="2" iCount="0" pCount="0" pgCount="1" format="0"   pidVer="2.0" timeout="10000"  wadh="" posh="" env="P" /> <CustOpts><Param name="mantrakey" value="" /></CustOpts>'+
                 '</PidOptions>';
        }

        const preUrl = localStorage.getItem('MantraRdUrll');
        if (preUrl) {
            url = preUrl;
        } else {
            if (testMantraPort === 1) {
                url = `https://127.0.0.1:11100/rd/capture`;
            } else if (testMantraPort === 2) {
                url = 'https://127.0.0.1:11101/rd/capture';
            } else if (testMantraPort === 3) {
                url = 'https://127.0.0.1:8005/rd/capture';
            }

        }
    } else if (deviceType === 'Tatvik') {
        url = 'https://127.0.0.1:11100/rd/capture';
    }
    

    var xhr;
    setFingerprintLoader(true);
    xhr = new XMLHttpRequest();
    xhr.open('CAPTURE', url, true);
    xhr.setRequestHeader('Content-Type', 'text/xml');
    xhr.setRequestHeader('Accept', 'text/xml');

    xhr.onreadystatechange = async function () {

        if (xhr.readyState === 4) {
            var status = xhr.status;

            if (status === 200) {
                var test1 = xhr.responseText;
                var test2 = test1.search('errCode');
                var test6 = getPosition(test1, '"', 2);
                var test4 = test2 + 9;
                var test5 = test1.slice(test4, test6);

                const fingerPrirntData = await Buffer.from(xhr.responseText).toString('base64');
                convertXmlToJs(xhr.responseText).then((result) =>{ 
                    const error =	result?.PidData?.Resp[0].$;
                    if (deviceType === 'Mantra') {
                        if (testMantraPort === 1) {
                            const url = `https://127.0.0.1:11100/rd/capture`;
                            localStorage.setItem('MantraRdUrl', url);
                        } else if (testMantraPort === 2) {
                            const url = 'https://127.0.0.1:11101/rd/capture';
                            localStorage.setItem('MantraRdUrl', url);
                        } else if (testMantraPort === 3) {
                            const url = 'https://127.0.0.1:8005/rd/capture';
                            localStorage.setItem('MantraRdUrl', url);
                        }
                    }
                    setFingerprintLoader(false);
                    if(Number(error.errCode) != 0){
                        setLoading(false);
                        setAlert({ type: 'error', msg: error.errInfo });
                       
    
                        return;
                    }else{
                        setAlert({ type: 'success', msg: 'FingerPrint Captured Successfully' });
                        setLoading(false);
                       
                        param.pid_xml_base64e = fingerPrirntData;
                        if (type === 'customer') {
                            if (controls.transactionType === 'Withdrawal') {
                                setLoading(true);
                                diosmCashwithdrawal(param).then((res) => {
                                    setLoading(false);
                                     if (res?.data) {
                                        setControls({ ...initialControls });
                                        setOverLayer(true);
                                        overLayers(true);
                                        setBankDataResp(res.data);
                                    //	setAepsStatus('selectDeviceForTransaction');
                                    } else {
                                        setOverLayer(false);
                                        setAepsStatus("yes");
                                        setControls({ ...initialControls });
                                        if (res?.errorCodeList.length > 0) {
                                            setAlert({ type: 'error', msg: res?.errorCodeList[0],  });
                                        } else {
                                            setAlert({ type: 'error', msg: res?.msg,  });
                                        }
                                    }
                                });
                            }
                            if (controls.transactionType === 'enquiry') {
                                setLoading(true);
                                diosmBalanceEnquiry(param).then((res) => {
                                    setLoading(false);
                                     if (res?.data) {
                                        setControls({ ...initialControls });
                                        setOverLayer(true);
                                        overLayers(true);
                                        setBankDataResp(res.data);
                                    //	setAepsStatus('selectDeviceForTransaction');
                                    } else {
                                        setOverLayer(false);
                                        setAepsStatus("yes");
                                        setControls({ ...initialControls });
                                        if (res?.errorCodeList.length > 0) {
                                            setAlert({ type: 'error', msg: res?.errorCodeList[0] });
                                        } else {
                                            setAlert({ type: 'error', msg: res?.msg,  });
                                        }
                                    }
                                });
                            }
                            if (controls.transactionType === 'statement') {
                                setLoading(true);
                                diosmMiniStatement(param).then((res) => {
                                    setLoading(false);
                                     if (res?.data) {
                                        setControls({ ...initialControls });
                                        setOverLayer(true);
                                        overLayers(true);
                                        setBankDataResp(res?.data);
                                        //setAepsStatus('selectDeviceForTransaction');
                                    } else {
                                        setOverLayer(false);
                                        setAepsStatus("yes");
                                        setControls({ ...initialControls });
                                        if (res?.errorCodeList.length > 0) {
                                            setAlert({ type: 'error', msg: res?.errorCodeList[0],  });
                                        } else {
                                            setAlert({ type: 'error', msg: res?.msg,  });
                                        }
                                    }
                                });
                            }
                        } else if (type === 'verify') {
                            setLoading(false);
                            diosmVerifyFingerprint(setLoading,setAepsStatus,setAlert,fingerPrirntData,deviceType);
                        } else {
                            setLoading(false);
                            diosmDailyLogin(setLoading,setAepsStatus,setAlert,fingerPrirntData,deviceType,controls);
                        }
                         
                        // convertXmlToJs(xhr.responseText).then((result) =>{
                        //     setFingerprintLoader(false);
                        //  var errCode = result?.PidData?.Resp[0]?.$?.errCode
                        
                        //     if(errCode == 0){
                        //         setLoading(false);
                        //         setAlert({ type: 'success', msg: 'FingerPrint Captured Successfully',  });
    
                             
                
                        //     }else if(errCode < 0){
                        //         setLoading(false);
                        //         setAlert({ type: 'error', msg: 'Device not connceted',  });
                        //     }else if(errCode == 720){
                        //         setAlert({ type: 'error', msg: 'Device is not ready',});
                        //     }else{
                        //         setAlert({ type: 'error', msg: 'FingerPrint Captured  Failed',});
                        //     }
                        //     return;
                        // })
                     
                    }
                })

               
            } else {
                setLoading(false);
                setFingerprintLoader(false);
            }
        }
    };

    xhr.onerror = function () {
        if (deviceType === 'Mantra') {
            setLoading(false);
            if (testMantraPort < 3) {
                testMantraPort = testMantraPort + 1;
                DiosmCapture(param, type,deviceType,aepsStatus,setBankDataResp,overLayers,setOverLayer,setControls,setFingerprintLoader,controls,setAepsStatus,setAlert,setLoading)
            }
        } 
        if (deviceType === 'Morpho') {
            setLoading(false);
            if (testMantraPort < 2) {
                testMantraPort = testMantraPort + 1;
                DiosmCapture(param, type,deviceType,aepsStatus,setBankDataResp,overLayers,setOverLayer,setControls,setFingerprintLoader,controls,setAepsStatus,setAlert,setLoading)
            }
        } 
        

    };
    xhr.send(PIDOPTS);
}

function convertXmlToJs(xmlData) {
    return new Promise((resolve, reject) => {
        parseString(xmlData, (err, result) => {
            if (err) {
                reject(err);
            } else {
                resolve(result);
            }
        });
    });
}

  //     const echoParam = {
                //         initiator_id: '7625004104',
                //         user_code: '35673004',
                //         customer_id: '9939181700',
                //         client_ref_id: '202105311125123954',
                //         latlong: '123.0000,234.002344',
                //         reference_tid: 'EKYKF5988537150324104052321I',
                //         otp_ref_id: '3437747',
                //         bank_code: 'INDIAN BANK',
                //         ekyc_flag: '1',
                //         aadhar: 'RdNjV4HD+8ySWcC20jRQJnx4J9klLQj2RJ8E9h4/8erJ3IWoREgeyLjQijugwl8y1YVK03BeXphSt9FyjpWTdKR46/7sUJHb5wMDbHZfuhUobEmeO5bhjEMSbetNskYWaRMA+a1JyOejU5KI5Kmn44qBVSzzHziUP8EE05cMXZQ= ',
                //         piddata: xhr.responseText,
                //     };

                //  console.log('echoParam', JSON.stringify(echoParam));